import {RRLogisticType} from "./RRLogisticType";

export const logisticsFBConverter = {
    fromFirestore: (snapshot: any, options: any): RRLogisticType => {
        const data = snapshot.data(options);
        return {
            id: snapshot.id,
            revision: data.revision ?? 0,
            driverId: data.driverId,
            driverName: data.driverName || "",
            dayType: data.dayType || "WORKDAY",
            startDate: data.startDate.toDate(),
            endDate: data.endDate.toDate(),
            workInStore: data.workInStore ?? false,
            eventNumber: data.eventNumber,
            isOwn: data.isOwn ?? true,
            truck: data.truck,
            startKm: data.startKm ?? 0,
            startPoint: data.startPoint || "",
            endPoint: data.endPoint || "",
            planNotes: data.planNotes || "",
            reportStartDate: data.reportStartDate ? data.reportStartDate.toDate() : null,
            reportEndDate: data.reportEndDate ? data.reportEndDate.toDate() : null,
            endKm: data.endKm ?? 0,
            reportNotes: data.reportNotes || ""
        };
    },
    toFirestore: (logistic: RRLogisticType) => {
        return {
            driverId: logistic.driverId,
            driverName: logistic.driverName,
            dayType: logistic.dayType || "WORKDAY",
            startDate: logistic.startDate,
            endDate: logistic.endDate,
            workInStore: logistic.workInStore ?? false,
            eventNumber: logistic.eventNumber,
            isOwn: logistic.isOwn,
            truck: logistic.truck,
            startKm: logistic.startKm ?? 0,
            startPoint: logistic.startPoint || "",
            endPoint: logistic.endPoint || "",
            planNotes: logistic.planNotes || "",
            reportStartDate: logistic.reportStartDate,
            reportEndDate: logistic.reportEndDate,
            endKm: logistic.endKm ?? 0,
            reportNotes: logistic.reportNotes || ""
        };
    }
}
